export default __webpack_public_path__ + "static/media/024-narwhal.11aec78d.svg";